import { FC, ReactNode, useMemo, useEffect, useState, useCallback } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { isMobileSelector } from 'selectors/viewportSelectors'
import styles from 'components/atoms/ReadMore/ReadMore.styl'

type ReadMoreProps = {
  wideLimit: number
  narrowLimit: number
  text: string
  readMoreChild?: ReactNode
}
export const ReadMore: FC<ReadMoreProps> = (props) => {
  const { text, wideLimit, narrowLimit, readMoreChild = 'Read More' } = props
  const isMobile = useStoreSelector(isMobileSelector)

  const [isExpanded, setExpanded] = useState(false)
  useEffect(() => {
    setExpanded(false)
  }, [isMobile])

  const currentLimit = isMobile ? narrowLimit : wideLimit
  const isTooLong = text.length > currentLimit

  const currentText = useMemo(() => {
    if (isExpanded || !isTooLong) {
      return text
    }

    let spaceIndex = text.lastIndexOf(' ', currentLimit)
    if (spaceIndex === -1) {
      spaceIndex = currentLimit
    }

    return text.substr(0, spaceIndex).trim().replace(/.$/, '')
  }, [currentLimit, text, isExpanded, isTooLong])


  const handleExpand = useCallback(() => {
    setExpanded(true)
  }, [])

  const displayReadMore = isTooLong && !isExpanded

  return (
    <>
      { currentText }
      { displayReadMore && (
        <span className={ styles.ellipsis }>&#x2026;</span>
      )}
      {' '}
      { displayReadMore && (
        <span onClick={ handleExpand } className={ styles.readMore }>
          { readMoreChild }
        </span>
      )}
    </>
  )
}
